// // import React, { useEffect } from "react";
// // import "./assets/scss/themes.scss";
// // import RouteIndex from "Routes/Index";
// // import {
// //   loginSuccess,
// //   headingData,
// //   permissionData,
// // } from "slices/auth/login/reducer";
// // import { ROLE, PERMISSION, USER_ID, TOKEN } from "constants/enums";
// // import { useDispatch } from "react-redux";

// // function App() {
// //   let dispatch = useDispatch();
// //   const userId = JSON.parse(window.localStorage.getItem(USER_ID));
// //   const permission = JSON.parse(window.localStorage.getItem(PERMISSION));

// //   useEffect(() => {
// //     if (userId) {
// //       dispatch(loginSuccess(userId));
// //       dispatch(headingData(userId));
// //     }
// //     if (permission) {
// //       dispatch(permissionData(permission));
// //     }
// //   }, [userId, permission]);

// //   return <RouteIndex />;
// // }

// // export default App;


// import React, { useEffect, useRef } from "react";
// import "./assets/scss/themes.scss";
// import RouteIndex from "Routes/Index";
// import {
//   loginSuccess,
//   headingData,
//   permissionData,
// } from "slices/auth/login/reducer";
// import { ROLE, PERMISSION, USER_ID, TOKEN } from "constants/enums";
// import { useDispatch } from "react-redux";

// function App() {
//   const dispatch = useDispatch();
//   const hasInitialized = useRef(false);

//   useEffect(() => {
//     // Only run once on mount
//     if (hasInitialized.current) {
//       return;
//     }
    
//     hasInitialized.current = true;
    
//     console.log("🚀 App.tsx - Initializing from localStorage");
    
//     const userId = JSON.parse(window.localStorage.getItem(USER_ID) || 'null');
//     const permission = JSON.parse(window.localStorage.getItem(PERMISSION) || 'null');
    
//     if (userId) {
//       console.log("✅ App.tsx - Found userId in localStorage:", userId);
//       dispatch(loginSuccess(userId));
//       dispatch(headingData(userId));
//     }
    
//     if (permission) {
//       console.log("✅ App.tsx - Found permission in localStorage");
//       dispatch(permissionData(permission));
//     }
//   }, []); // Empty dependency array - only run once

//   return <RouteIndex />;
// }

// export default App;


import React, { useEffect, useRef } from "react";
import "./assets/scss/themes.scss";
import RouteIndex from "Routes/Index";
import {
  loginSuccess,
  headingData,
  permissionData,
} from "slices/auth/login/reducer";
import { ROLE, PERMISSION, USER_ID, TOKEN } from "constants/enums";
import { useDispatch } from "react-redux";

function App() {
  const dispatch = useDispatch();
  const hasInitialized = useRef(false);

  console.log("🔵 APP.TSX RENDER - hasInitialized:", hasInitialized.current);

  useEffect(() => {
    console.log("🟡 APP.TSX useEffect triggered - hasInitialized:", hasInitialized.current);
    
    // Only run once on mount
    if (hasInitialized.current) {
      console.log("⚠️ APP.TSX - Already initialized, skipping");
      return;
    }
    
    hasInitialized.current = true;
    
    console.log("🚀 App.tsx - Initializing from localStorage");
    
    const userId = JSON.parse(window.localStorage.getItem(USER_ID) || 'null');
    const permission = JSON.parse(window.localStorage.getItem(PERMISSION) || 'null');
    
    console.log("📦 localStorage values:", { userId, permission });
    
    if (userId) {
      console.log("✅ App.tsx - Dispatching loginSuccess with userId:", userId);
      dispatch(loginSuccess(userId));
      dispatch(headingData(userId));
    } else {
      console.log("❌ App.tsx - No userId in localStorage");
    }
    
    if (permission) {
      console.log("✅ App.tsx - Dispatching permissionData");
      dispatch(permissionData(permission));
    } else {
      console.log("❌ App.tsx - No permission in localStorage");
    }
  }, []); // Empty dependency array - only run once

  console.log("🟢 APP.TSX - Returning RouteIndex");
  return <RouteIndex />;
}

export default App;